import axios from 'axios';

export const signInUser = credentials => {
    return new Promise((resolve, reject) => {
        axios
            .post('user/login', credentials)
            .then((response) => resolve(response.data))
            .catch(reject);
    });
};

export const resetUserPassword = payload => {
    return new Promise((resolve, reject) => {
        axios
            .post('user/resetpassword', payload)
            .then((response) => resolve(response.data))
            .catch(reject);
    });
};
